import React from 'react';
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

export interface Option {
    label: string | React.ReactNode;
    value: any;
    onClickValue?: any;
}

interface IMuiRadioGroupProps {
    label?: string;
    value: any;
    options: Option[];
    renderActionButton?: (option: Option) => React.JSX.Element | null;
    onChange: (value: string) => void;
    onClick?: (onClickValue: any) => void;
}

export const MuiRadioGroup: React.FC<React.PropsWithChildren<IMuiRadioGroupProps>> = props => {
    const { label, value, options, onChange, renderActionButton, onClick } = props;

    const handleChange = React.useCallback(
        (_event: any, newValue: string) => {
            onChange(newValue);
        },
        [onChange]
    );

    const handleClick = React.useCallback(
        (onClickValue: any) => () => onClick && onClick(onClickValue),
        [onClick]
    );
    const renderRadioButton = React.useCallback(
        (option: Option) =>
            renderActionButton ? (
                <Box display="flex" alignItems="center" justifyContent="space-between" key={option.value}>
                    <FormControlLabel
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                        onClick={handleClick(option.onClickValue)}
                        sx={{
                            flex: '1'
                        }}
                    />
                    {renderActionButton(option)}
                </Box>
            ) : (
                <FormControlLabel
                    value={option.value}
                    control={<Radio />}
                    label={option.label}
                    key={option.value}
                    onClick={handleClick(option.onClickValue)}
                />
            ),
        [handleClick, renderActionButton]
    );

    return (
        <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup name="mui-radio-group" value={value} onChange={handleChange}>
                {options.map(renderRadioButton)}
            </RadioGroup>
        </FormControl>
    );
};
